import {
  gridGutterHalf,
  fontSize18,
  gridGutter1q4
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";

import theme from "../../../../js/shared/new-theme";

export const defaultStyle = `
  border-radius: 4px;
  display: flex;
  align-items: center;

  h3 {
    font-size: ${fontSize18};
    font-weight: bold;
    color: ${theme.palette.gray[800].value};
    margin: 0 ${gridGutterHalf}px 0 ${gridGutter1q4}px;
  }

  span {
    margin-top: 2px;
    color: ${theme.palette.gray[600].value};
  }
`;
